import { createContext, useContext } from 'react'

export function createUseStore<T>(store: { new (...args: any): T }) {
  const context = createContext<T | null>(null)

  function useFunc(): T {
    const foundContext = useContext(context)
    if (!foundContext) throw new Error(`use${store.name} must be within ${store.name}Context.Provider`)

    return foundContext
  }

  return [context, useFunc] as const
}
